import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const GetDisplayById = {
  name: 'GetDisplayById',
  state: {
    data: {},
    loading: false,
    error: '',
  },
  reducers: {
    fetchRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    fetchSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
      };
    },

    fetchFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
    clearData(state) {
      return {
        ...state,
        data: {},
        error: '',
      };
    },
  },
  effects: (dispatch) => ({
    async fetchDisplayById(id) {
      try {
        this.fetchRequested();
        const org_id = JSON.parse(localStorage.getItem('userInfo')).org_id;
        const Id = id;
        const url = `savvy/displays/${Id}?org_id=${org_id}`;
        const response = await http.get(url);
        this.fetchSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Display fetched successfully!',
            show: true,
          },
        });
      } catch (error) {
        this.fetchFailed(error.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(error.message),
            show: true,
          },
        });
      }
    },
    clearFetchedData() {
      this.clearData();
    },
  }),
};

export default GetDisplayById;
